import React from 'react';
import PropTypes from 'prop-types';

import MDTypography from 'components/MDTypography';

const TableTypography = ({ value, sx }) => {
  return (
    <MDTypography fontSize="14px" sx={sx} color="text">
      {value}
    </MDTypography>
  );
};

TableTypography.propTypes = {
  value: PropTypes.any,
  sx: PropTypes.any,
};

TableTypography.defaultProps = {
  value: '',
  sx: {
    maxWidth: '40ch',
  },
};

export default TableTypography;
